import { Message } from 'element-ui';
import {
    barcodeField,
    bidPriceField,
} from "@/api/system-set";
export const tiaoma = ({ info, position }) => {
    console.log(info, position, 'info, position info, position info, position info, position ')
    // setprintxp　　setprinttm　setprintbjq　对应　getprintxp　　getprinttｍ　getprintbjq
    // console.log(position.is_scantling); //0称重 1计件
    let printS;
    //ｔｙｐｅ=０小票或交班　　１条码　２标价签
    if (info.type == 0) {
        printS = window.getprintxp();
        if (!printS) { Message.error("获取打印机失败！"); return false };
        let print = JSON.parse(printS);
        if (info.sType == "jiaoban") {
            return jiaoban(info, position, print);
        } else if (info.sType == "dingdan") {
            return tiaomaDd(info, position, print);
        } else {
            return tiaomaXp(info, position, print);
        }
    }
    if (info.type == 1) {
        printS = window.getprinttm();
        if (!printS) { Message.error("获取打印机失败！"); return false };
        let print = JSON.parse(printS);
        return tiaomaYi(info, position, print);
    }
    if (info.type == 2) {

        // printS = '{"printname":"Xj-test","adjx":10,"adjy":10,"font":12}'

        printS = window.getprintbjq();
        if (!printS) { Message.error("获取打印机失败！"); return false };
        let print = JSON.parse(printS);
        return biaojiaqian(info, position, print);
    }
    console.log("打印机是", print);
};
async function tiaomaYi(info, position, print) {
    let config = await barcodeField()
    console.log(config.data);
    let configarr = config.data.field
    let showgoods_name = configarr.find((item) => item.flield_name == '商品名称').checked
    let showpackaging_date = configarr.find((item) => item.flield_name == '包装日期').checked
    let showgoods_number = configarr.find((item) => item.flield_name == '数量').checked
    let showgoods_price = configarr.find((item) => item.flield_name == '单价').checked
    let showsale_price = configarr.find((item) => item.flield_name == '零售价/小计').checked
    let showbar_code = configarr.find((item) => item.flield_name == '条码').checked
    let showvip_price = configarr.find((item) => item.flield_name == '会员价').checked
    let printerNumbers = info.isDefaultNumbers ? config.data.printer_number : info.copies
    let positionItem = [
        // 第一行
        {
            x: 0,
            y: 0,
            text: position.name,
            font: print.font + 5, //０是二维码　　１是条码   >１是字号
            B: 2,
            type: 0,
            show: showgoods_name
        },
        // 第2行
        {
            x: 5,
            y: 15,
            text: "包装日期",
            font: print.font,
            type: 0,
            show: showpackaging_date
        },
        {
            x: 35,
            y: 15,
            text: position.is_scantling == 1 ? "数量" : "重量",
            font: print.font,
            type: 0,
            B: 1,
            show: showgoods_number
        },
        {
            x: 65,
            y: 15,
            text: "价格",
            font: print.font,
            type: 0,
            show: showgoods_price
        },
        // 第3行
        {
            x: 5,
            y: 25,
            text: getnowDate(),
            font: print.font,
            type: 0,
            show: showpackaging_date
        },
        {
            x: 35,
            y: 25,
            text: (()=>{
                if(position.is_scantling == 1){
                    return `${position.number}`
                }
                let unitText = 'kg';
                if(position.unitText){
                    unitText = position.unitText;
                }
                return `${position.weightCheng}${unitText}`;
            })(),
            font: print.font,
            type: 0,
            show: showgoods_number
        },
        {
            x: 65,
            y: 25,
            text: String(position.price),
            font: print.font,
            type: 0,
            show: showgoods_price
        },
        // 第4行
        {
            x: 5,
            y: 35,
            text: "小计：" + position.total + "元",
            font: print.font + 2,
            type: 0,
            show: showsale_price
        },
        {
            x: 37,
            y: 35,
            text: `会员价： ${position.memberPrice}元`,
            font: print.font + 2,
            type: 0,
            show: showvip_price
        },
        // 第五行 条码
        {
            x: 5,
            y: 45,
            text: "条形码",
            font: print.font,
            type: 1,
            B: 1,
            show: showbar_code
        },
        // 第六行
        {
            x: 2,
            y: 55,
            text: position.code,
            font: print.font,
            B: 1,
            type: 1,
            show: showbar_code
        }
    ]
    positionItem = positionItem.filter((item) => item.show === true)
    return {
        info: {
            w: info.w,
            h: info.h,
            printername: print.printname,
            copies: printerNumbers,
            adjx: print.adjx || 10, //偏移
            adjy: print.adjy || 10, //偏移
            type: 1
        },
        //  info.type == 1
        position: positionItem
    };
}
async function biaojiaqian(info, position, print) {
    let config = await bidPriceField()
    console.log(config.data);
    let configarr = config.data.field
    let showpackaging_date = configarr.find((item) => item.flield_name == '包装日期').checked
    let showgoods_name = configarr.find((item) => item.flield_name == '商品名称').checked
    let showorigin = configarr.find((item) => item.flield_name == '产地').checked
    let showunit = configarr.find((item) => item.flield_name == '单位').checked
    let showspec = configarr.find((item) => item.flield_name == '规格').checked
    let showlevel = configarr.find((item) => item.flield_name == '等级').checked
    let showbar_code = configarr.find((item) => item.flield_name == '条码').checked
    let showvip_price = configarr.find((item) => item.flield_name == '会员价').checked
    let showsale_price = configarr.find((item) => item.flield_name == '零售价/小计').checked
    let positionItem = [
        // 第一行 日期
        {
            x: 45,
            y: 0,
            text: getnowDate(),
            font: print.font + 5, //０是二维码　　１是条码   >１是字号
            B: 2,
            type: 0,
            show: showpackaging_date
        },
        // 第2行 品名
        {
            x: 7,
            y: 13,
            text: position.name,
            font: print.font + 6,
            type: 0,
            show: showgoods_name
        },
        // 3 产地  单位
        {
            x: 5,
            y: 28,
            text: "暂无",
            font: print.font,
            B: 1,
            type: 0,
            show: showorigin
        },
        {
            x: 28,
            y: 28,
            text: position.unit,
            font: print.font,
            type: 0,
            show: showunit
        },
        // 4 规格 等级
        {
            x: 5,
            y: 37,
            text: "元/" + (position.weight_type || "kg"),
            font: print.font,
            type: 0,
            show: showspec
        },
        {
            x: 28,
            y: 37,
            text: "暂无",
            font: print.font,
            type: 0,
            show: showlevel
        },
        {
            x: 59,
            y: 37,
            text: '会员价：' + String(Number(position.desk_price) * Number(position.desk_vip_discount) / 10),
            font: print.font,
            type: 0,
            show: showlevel
        },
        // 5 条码
        {
            x: 6,
            y: 45,
            text: String(position.code),
            font: print.font,
            type: 1,
            show: showbar_code
        },
        // 6 零售价
        {
            x: 59,
            y: 58,
            text: String(position.desk_price),
            font: print.font + 10,
            type: 0,
            show: showsale_price
        }
    ]
    // 默认打印分数
    let printerNumbers = info.isDefaultNumbers ? config.data.printer_number : info.copies
    positionItem = positionItem.filter((item) => item.show === true)
    return {
        info: {
            w: info.w,
            h: info.h,
            printername: print.printname,
            copies: printerNumbers,
            adjx: print.adjx || 10, //偏移
            adjy: print.adjy || 10, //偏移
            type: 2 //ｔｙｐｅ=０小票或交班　　１条码　２标价签
        },
        //  info.type == 1
        // type 0为字符 1为条码 2为二维码
        position: positionItem
    };
}
// 小票和交班　ｙ传行数　第一行传０　第二行传１
function tiaomaXp(info, position, print) {
    let arr = [];
    console.log(position, "positionposition");
    let yVal = 0;
    let zdyStr = 0;
    let splitInit = 0; // 商品数
    position.forEach((item, index) => {
        if (item.type == "header") {
            arr.push({
                x: 28,
                y: yVal + index,
                text: item.value,
                font: print.font + 5,
                type: 0
            });
            yVal = 2
        }
        if (item.type == "normal") {
            arr.push({
                x: 5,
                y: yVal + index + zdyStr,
                text: item.text,
                font: print.font,
                type: 0
            });
            if (item.text == '自定义说明') {
                let regex = new RegExp(".{1," + 16 + "}", "g");
                let newStr = item.value.match(regex).join("\r\n");
                console.log(newStr, 'newStrnewStrnewStrnewStr')
                let arrStr = newStr.split("\r\n")
                arrStr.forEach((item, sindex) => {
                    arr.push({
                        x: 28,
                        y: yVal + index + zdyStr,
                        text: item,
                        font: print.font,
                        type: 0
                    });
                    zdyStr += 2
                })
                // zdyStr = (newStr.split("\r\n").length - 1) * 2

            } else {
                arr.push({
                    x: 28,
                    y: yVal + index + zdyStr,
                    text: item.value,
                    font: print.font,
                    type: 0
                });
            }

        }
        if (item.type == "split") {
            if (item.text.endsWith("/")) {
                item.text = item.text.slice(0, -1);
            }
            let arr2 = item.text.split("/");
            let length = 80 / arr2.length;

            console.log('arr2==>', {
                arr2, index
            });



            // arr2.forEach((j, i) => {

            //     arr.push({
            //         x: i * length + 5,
            //         y: yVal + index + zdyStr,
            //         text: j,
            //         font: print.font,
            //         type: 0
            //     });

            // });




            let lastY = 0;
            arr2.forEach((j, i) => {

                let resY = splitInit + yVal + index + zdyStr;

                if (i != 0 && splitInit >= 1) {
                    resY++;
                }

                lastY = resY;


                arr.push({
                    x: i * length + 5,
                    y: splitInit == 0 ? resY : resY-1,
                    text: j,
                    font: print.font,
                    type: 0
                });


            });



            splitInit++;


            if (!position.slice(index + 1).some(i => i.type == 'split')) {
                if (lastY != 0) {
                    yVal = lastY - index;
                }
            }





        }
        if (item.type == "tiaoma") {
            arr.push({
                x: 5,
                y: yVal + index + zdyStr,
                text: item.value,
                font: print.font,
                type: 1
            });
            // yVal = 6;
            yVal = 6 + splitInit;
        }
        if (item.type == "qr") {
            let val = index;
            val = index + yVal + zdyStr;
            if (item.text == "发票二维码") {
                val = val + 8;
            }
            if (item.text == "小程序二维码") {
                arr.push({ x: 20, y: val + 3, text: item.text, font: print.font, type: 0 });
                arr.push({ x: 15, y: val + 5, text: item.value, font: print.font, type: 2 });
            } else {
                arr.push({ x: 15, y: val + 6, text: item.text, font: print.font, type: 0 });
                arr.push({ x: 15, y: val + 10, text: item.value, font: print.font, type: 2 });
            }

        }
    });
    console.log(arr, "arrrarrrarrrarrrarrrarrrarrrarrr");
    console.log(info, "infoinfoinfoinfoinfoinfoinfoinfo");
    return {
        info: {
            w: info.w,
            h: info.h,
            printername: print.printname,
            copies: info.copies,
            adjx: print.adjx || 10, //偏移
            adjy: print.adjy || 10, //偏移
            type: 0
        },
        //  info.type == 1
        position: arr
    };
}
// 订单
// 小票和交班　ｙ传行数　第一行传０　第二行传１
function tiaomaDd(info, position, print) {
    let arr = [];
    console.log(position, "positionposition");
    position.forEach((item, index) => {
        if (item.type == "header") {
            arr.push({
                x: 0,
                y: index,
                text: item.value,
                font: print.font + 5,
                type: 0
            });
        }
        if (item.type == "normal") {
            arr.push({ x: 5, y: index, text: item.text, font: print.font, type: 0 });
            arr.push({
                x: 35,
                y: index,
                text: item.value,
                font: print.font,
                type: 0
            });
        }
        if (item.type == "split") {
            if (item.text.endsWith("/")) {
                item.text = item.text.slice(0, -1);
            }
            let arr2 = item.text.split("/");
            let length = 80 / arr2.length;
            arr2.forEach((j, i) => {
                arr.push({
                    x: i * length,
                    y: index,
                    text: j,
                    font: print.font,
                    type: 0
                });
            });
        }
    });
    console.log(arr, "arrrarrrarrrarrrarrrarrrarrrarrr");
    console.log(info, "infoinfoinfoinfoinfoinfoinfoinfo");
    return {
        info: {
            w: info.w,
            h: info.h,
            printername: print.printname,
            copies: info.copies,
            adjx: print.adjx || 10, //偏移
            adjy: print.adjy || 10, //偏移
            type: 0
        },
        //  info.type == 1
        position: arr
    };
}

function jiaoban(info, position, print) {
    return {
        info: {
            w: info.w,
            h: info.h,
            printername: print.printname,
            copies: info.copies,
            adjx: print.adjx || 10, //偏移
            adjy: print.adjy || 10, //偏移
            type: 0 //ｔｙｐｅ=０小票或交班　　１条码　２标价签
        },
        //  info.type == 1
        position: [
            // 第一行
            {
                x: 0,
                y: 0,
                text: position.name,
                font: print.font + 5, //０是二维码　　１是条码   >１是字号
                B: 2,
                type: 0
            },
            // 第2行
            {
                x: 5,
                y: 1,
                text: "打印时间：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 1,
                text: position.printTime,
                font: print.font,
                B: 1,
                type: 0
            },
            // 第3行
            {
                x: 5,
                y: 2,
                text: "姓名：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 2,
                text: position.userName,
                font: print.font,
                type: 0
            },
            // 第4行
            {
                x: 5,
                y: 3,
                text: "账号：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 3,
                text: position.mobile,
                font: print.font,
                type: 0
            },
            // 第五行 条码
            {
                x: 5,
                y: 4,
                text: "上班时间：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 4,
                text: position.duration,
                font: print.font,
                type: 0
            },
            // 第六行
            {
                x: 5,
                y: 5,
                text: "工作时长：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 5,
                text: position.duration,
                font: print.font,
                type: 0
            },
            // 第七行
            {
                x: 5,
                y: 6,
                text: "销售总金额：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 6,
                text: String(position.total_marker_money),
                font: print.font,
                type: 0
            },
            // 第八行
            {
                x: 5,
                y: 7,
                text: "充值总金额：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 7,
                text: String(position.total_marker_money),
                font: print.font,
                type: 0
            },
            // 第九行
            {
                x: 5,
                y: 8,
                text: "收款总金额：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 8,
                text: String(position.total_marker_money),
                font: print.font,
                type: 0
            },
            // 第十行
            {
                x: 5,
                y: 9,
                text: "销售订单数：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 9,
                text: String(position.order_number),
                font: print.font,
                type: 0
            },
            // 第十一行
            {
                x: 5,
                y: 10,
                text: "充值订单数：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 10,
                text: String(position.recharge_number),
                font: print.font,
                type: 0
            },
            // 第十二行
            {
                x: 5,
                y: 11,
                text: "退款订单数：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 11,
                text: String(position.refund_order),
                font: print.font,
                type: 0
            },
            // 第十三行
            {
                x: 5,
                y: 12,
                text: "退款金额：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 12,
                text: String(position.return_money),
                font: print.font,
                type: 0
            },
            // 第十四行
            {
                x: 5,
                y: 13,
                text: "员工备注：",
                font: print.font,
                type: 0
            },
            {
                x: 35,
                y: 13,
                text: "备注",
                font: print.font,
                type: 0
            },
            // 第十五行
            {
                x: 5,
                y: 14,
                text: "员工签字：",
                font: print.font,
                type: 0
            }
        ]
    };
}
function getnowDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}.${month}.${day}`;
    return formattedDate;
}



// WEBPACK FOOTER //
// ./src/utils/dataJSon.js